import { render, staticRenderFns } from "./author-user-details.html?vue&type=template&id=b72fba38&scoped=true&"
import script from "./author-user-details.js?vue&type=script&lang=js&"
export * from "./author-user-details.js?vue&type=script&lang=js&"
import style0 from "./author-user-details.scss?vue&type=style&index=0&id=b72fba38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72fba38",
  null
  
)

export default component.exports